<template>
  <v-card class="invpreview" :class='pdf' :flat='pdf ==="pdf"'>
    <v-card-text>
<v-layout align-center justify-center row fill-height >
      <v-flex xs9 text-xs-left >
        <!-- <img :src="imageUrl" :width="invoice.logoWidth" :class="invoice.logoAlign"> -->
        <img v-if="invoice.useLogo" :src="imageUrl" :width="invoice.logoWidth" class="left invoicelogo">
      <span
      v-if="!invoice.useLogo && invoice.useLogo !== ''"
      class="bold"
      :style="{
        fontSize: `${invoice.logoNameSize}px`,
        whiteSpace: 'pre',
        lineHeight: '1.2em'
      }"
      >{{invoice.logoName}}</span>
      </v-flex>
      <v-flex xs3  text-xs-left>
        <h1 class="headline bold text-xs-right">Invoice</h1>
        <transition name="bounce">
      <!-- <div class="paidstamp" v-show='invoice.status === "Paid"'><img src="../../assets/paidstamp.png" alt="paid" ></div> -->
      <div class="paidstamp" v-show='invoice.status === "Paid"'><div>Paid</div></div>
    </transition>
      </v-flex>
    </v-layout>
      <v-layout row  :class="$vuetify.breakpoint.xsOnly ? 'mt-4' : 'mt-5'">
      <v-flex  xs8 >
        <h3 class="head-bar">Client details</h3>
        <div class="py-2 px-2">
          <span v-if='invoice.contact' class="d-block">{{invoice.contact}}</span>
          <span v-if='invoice.clientName' class="d-block">{{invoice.clientName}}</span>
          <span v-if='invoice.clientAddress' class="d-block" v-html="invoice.clientAddress" style="white-space: pre;"></span>
          <span v-if='invoice.clientAddress2' class="d-block">{{invoice.clientAddress2}}</span>
          <span v-if='invoice.clientTown' class="d-block">{{invoice.clientTown}}</span>
          <span v-if='invoice.clientCounty' class="d-block">{{invoice.clientCounty}}</span>
          <span v-if='invoice.clientCountry' class="d-block">{{invoice.clientCountry}}</span>
          <span v-if='invoice.postCode' class="d-block">{{invoice.postCode}}</span>
        </div>
      </v-flex>
      <v-flex xs4 offset-xs-1  text-xs-left>
        <h3 class="head-bar">Invoice details</h3>
        <div class="py-2 px-2">
          <div>
          <span class="bold pr-1 d-block">Invoice No</span>
          <span>{{ invoiceRef }}</span>
          </div>
          <div v-if="invoice.poNumber">
            <span class="bold pr-1 d-block mt-2">PO Number</span>
            <span>{{ invoice.poNumber}}</span>
          </div>
          <div>
            <span class="bold pr-1 d-block mt-2">Invoice Date</span>
            <span>{{ invoicedDateFormatted }}</span>
          </div>
        </div>
      </v-flex>
      </v-layout>
      <div class="mt-4">
        <div v-if="invoice.note" class="shortp py-2 px-2 " v-html="`<strong>Invoice note:</strong><br>${invoice.note.replace(/(?:\r\n|\r|\n)/g, '<br>')}`"></div>
        <div v-if="invoice.taxIncluded && invoice.chargeTax">
          <p class="body-tiny pl-2">Prices inclusive of {{invoice.taxLabel || "VAT"}}</p>
        </div>
        <table class="invoice-lines">
          <thead>
            <tr>
              <th><h3>Items</h3></th>
              <th v-if="invoice.chargeTax"><h3>Amount</h3></th>
              <th v-if="invoice.chargeTax"><h3>{{invoice.taxLabel || "VAT"}}</h3></th>
              <th><h3>Total</h3></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item) in invoice.lineItems"  :key="item.id">
              <td>
                {{item.description}}
              </td>
              <td v-if="invoice.chargeTax">
                {{item.netAmount | toCurrency(invoice.lang, invoice.currCode)}}
              </td>
              <td v-if="invoice.chargeTax">
                {{item.taxPortion | toCurrency(invoice.lang, invoice.currCode)}} <span class="body-tiny">({{item.taxRate}}&percnt;)</span>
              </td>
              <td>
                {{ item.lineTotal | toCurrency(invoice.lang, invoice.currCode) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-divider class="divider mb-2"></v-divider>
      <v-layout v-if="invoice.chargeTax" class="px-2">
        <v-flex xs9 text-xs-left >
          TOTAL (excl {{invoice.taxLabel || "VAT"}})
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ invoice.totalNetAmount | toCurrency(invoice.lang, invoice.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout v-if="invoice.chargeTax" class="px-2">
        <v-flex xs9 text-xs-left >
          TOTAL {{invoice.taxLabel || "VAT"}}
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ invoice.totalTaxPortion | toCurrency(invoice.lang, invoice.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout v-if="invoice.chargeTax" class="offwhite px-2 xbold">
        <v-flex xs9 text-xs-left >
          TOTAL (incl {{invoice.taxLabel || "VAT"}})
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ invoice.amount | toCurrency(invoice.lang, invoice.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout v-else class="offwhite px-2 xbold">
        <v-flex xs9 text-xs-left >
          TOTAL
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ invoice.amount | toCurrency(invoice.lang, invoice.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout row mt-5 class="invfooter">
        <v-flex xs8>
          <h3 class="head-bar">Payment &amp; Terms</h3>
          <div class="py-2 pl-2 pr-5">
            <span v-html="invoice.paymentTerms.replace(/(?:\r\n|\r|\n)/g, '<br>')" class="shortp"></span>
          </div>
        </v-flex>
        <v-flex xs4 text-xs-left>
          <h3 class="head-bar">Contact details</h3>
          <div class="py-2 px-2">
            {{ invoice.groupTitle}}<br>
            <address-display
              :groupAddress="invobj.groupAddress"
              :groupAddress1="invobj.groupAddress1"
              :groupAddress2="invobj.groupAddress2"
              :groupCityRegion="invobj.groupCityRegion"
              :groupCountyState="invobj.groupCountyState"
              :groupPostcode="invobj.groupPostcode"
              :groupCountry="invobj.groupCountry"
            ></address-display>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>

import AddressDisplay from '@/components/Shared/AddressDisplay'

export default {
  name: 'InvoicePreview',
  components: {
    AddressDisplay
  },
  props: [
    'invoice',
    'imageUrl',
    'invoicedDateFormatted',
    'pdf',
    'displayedInvoiceNumber'
  ],
  computed: {
    invoiceRef () {
      return this.displayedInvoiceNumber ? this.displayedInvoiceNumber : this.invoice.invoice_ref
    },
    invobj () {
      return this.invoice
    }
  }
}
</script>

<style lang="scss">
.invoicelogo{
  max-width:100%;
}
.xsOnly .invoicelogo{
  max-width:50%;
}
.headline{
    font-size: calc(20px + 1vw) !important;
}
table.invoice-lines{
  width:100%;
  border-collapse: collapse;
}

table.invoice-lines thead tr th{
  text-align:right;
  font-weight:700;
  padding:6px 8px;
  border-bottom:1px solid var(--light-text);
  background:var(--invoice-heading-bg);
}
table.invoice-lines thead tr th:first-child{
  text-align:left;
  width:100%;
}

table.invoice-lines tbody tr td{
  text-align:right;
  padding:0px 8px;
  white-space: nowrap;

}
table.invoice-lines tbody tr:first-child td{
padding-top:10px;
}
table.invoice-lines tbody tr:last-child td{
padding-bottom:10px;
}
table.invoice-lines tbody tr td:first-child{
  text-align:left;
  width:100%;
  white-space: normal;

}
.invoice-lines h3:first-child{
  margin-right:auto;
}
.head-bar{
  font-weight:700;
  padding:6px 8px;
  border-bottom:1px solid var(--light-text);
  background:var(--invoice-heading-bg);
  padding:6px 8px;
}

.invpreview{
  padding:30px;
  // leading grows along with font,
  font-size: calc(4px + .5vw);
  // with an additional 0.1em + 0.5px per 100px of the viewport
  line-height: calc(1.1em + 0.4vw);
  &.pdf{
    font-size:80%;
    line-height: 1.3rem;
    .head-bar{
      font-size:1.1rem;
    }
    .headline{
      font-size:2.8rem !important;
    }
  }
}
.xsOnly .invpreview{
  padding:0;
  font-size:55%;
}

.row{
    padding:5px 0;
}
.divider{
  background: var(--light-text);
}
.nowrap{
  white-space: nowrap;
}
.offwhite{
  background:var(--invoice-heading-bg);
}
.xsOnly .paidstamp div{
  font-size:1.5rem;

}
.paidstamp{
  // width:150px;
  // z-index:1;
  text-align: right;

  img{
    max-width:100%;
  }
  div{
    color:var(--red);
    font-size:2rem;
    font-weight:700;
  }
}

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(2);
    opacity:0;
  }
  100% {
    transform: scale(1);
    opacity:1;
  }
}
  span.shortp > p {
    margin: 0 !important;
    padding: 0;
    }
  .invfooter{
    p{
      padding-bottom:0;
      margin-bottom:0;
    }
  }
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit !important;
  }

</style>
